import revive_payload_client_4sVQNw7RlN from "/builds/webcontact/engelsbrand/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/webcontact/engelsbrand/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/webcontact/engelsbrand/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/webcontact/engelsbrand/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/webcontact/engelsbrand/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/webcontact/engelsbrand/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import components_plugin_KR1HBZs4kY from "/builds/webcontact/engelsbrand/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/webcontact/engelsbrand/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import matomo_client_u58QsgwcV0 from "/builds/webcontact/engelsbrand/node_modules/@webcontact/nuxt-kommunen/dist/runtime/plugins/matomo.client.mjs";
import vee_validate_gJ9GDooMl7 from "/builds/webcontact/engelsbrand/node_modules/@webcontact/nuxt-kommunen/dist/runtime/plugins/vee-validate.mjs";
import sentry_client_TgrSXJLeIY from "/builds/webcontact/engelsbrand/node_modules/@webcontact/nuxt-kommunen/dist/runtime/plugins/sentry.client.mjs";
import nuxt_kommunen_5mU9tAAkRV from "/builds/webcontact/engelsbrand/node_modules/@webcontact/nuxt-kommunen/dist/runtime/plugins/nuxt-kommunen.mjs";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  matomo_client_u58QsgwcV0,
  vee_validate_gJ9GDooMl7,
  sentry_client_TgrSXJLeIY,
  nuxt_kommunen_5mU9tAAkRV
]